import Card from "app/components/Card";
import {
  selectIsLoading,
  selectMyTickets,
} from "app/containers/Features/containers/Home/redux/selector";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import StatusCard from "./StatusCard";
import { TicketStatusWidgetSkeleton } from "./StatusCardSkeleton";

export default function TicketStatusWidget() {
  const myTickets = useSelector(selectMyTickets);
  const isLoading = useSelector(selectIsLoading);

  const renderContent = useCallback(() => {
    if (isLoading) {
      return <TicketStatusWidgetSkeleton />;
    }
    return (
      <div className="flex w-full gap-2.5 pr-2">
        {myTickets.map((categoryData, idx) => (
          <StatusCard
            key={idx}
            title={categoryData._id}
            data={categoryData.statuses || []}
          />
        ))}
      </div>
    );
  }, [isLoading, myTickets]);

  return (
    <Card className="flex h-[190px] flex-none flex-col rounded-md border border-[#E0E0E0] p-6 shadow-none">
      <span className="mb-4 block text-sm font-medium text-[#1F2937]">
        My tickets
      </span>
      {isLoading ? <TicketStatusWidgetSkeleton /> : renderContent()}
    </Card>
  );
}
